// constants
import { AVAILABILITY_STATE_VALUE_BUSY } from "../../../constants/availability";

/**
 * Retourne vrai si la date est déjà réservée.
 * @param {object} param0.availability Les informations de l'API à propos de la date courante.
 */
export default function availabilityIsBusy({ availability }) {
  return availability?.state === AVAILABILITY_STATE_VALUE_BUSY;
}
